import { FaceMesh, Results } from '@mediapipe/face_mesh';
import AvatarManager from './avatarManager';

class FaceMeshManager {
  private static instance = new FaceMeshManager();
  private faceMesh!: FaceMesh;
  private results!: Results;
  constructor() {
    this.createFaceMesh();
    this.initFaceMesh();
  }
  static getInstance() {
    return FaceMeshManager.instance;
  }
  async initFaceMesh() {
    if (!this.faceMesh) return;
    await this.faceMesh.initialize();
  }
  createFaceMesh() {
    this.faceMesh = new FaceMesh({
      locateFile: file => {
        return `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`;
      },
    });
    this.faceMesh.setOptions({
      selfieMode: true,
      enableFaceGeometry: false,
      maxNumFaces: 1,
      //refineLandmarks: false,
      refineLandmarks: true,
      minDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5,
    });
    this.faceMesh.onResults(this.onResults.bind(this));
  }
  getResults() {
    return this.results;
  }

  onResults(results: Results) {
    this.results = results;
    const avatarManager = AvatarManager.getInstance();
    avatarManager.updateFacialTransforms(results);
  }
  async updateFrames(videoEle: HTMLVideoElement) {
    await this.faceMesh.send({ image: videoEle });
  }
}

export { FaceMeshManager };
